import {
  ADD_TO_MY_DASHBORAD,
  RESET_REDUX_STATE,
  GET_WIDGETS_FOR_MY_DASHBOARD_TAB,
  GET_WIDGETS_FOR_OVERALL_TAB,
  GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB,
  GET_WIDGETS_FOR_USER_PERFORMANCE_TAB,
  GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB,
} from "../constants";

const initState = {
  myDashboardWidgets: [],
  overallTabWidgets: [],
  customerAnalysisWidgets: [],
  userPerformanceWidgets: [],
  collaboratorPerformanceWidgets: []
};

const analytics = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_TO_MY_DASHBORAD: {
      return {
        ...state,
        myDashboardWidgets: payload,
      };
    }

    case GET_WIDGETS_FOR_MY_DASHBOARD_TAB: {
      return {
        ...state,
        myDashboardWidgets: payload,
      };
    }

    case GET_WIDGETS_FOR_OVERALL_TAB: {
      return {
        ...state,
        overallTabWidgets: payload,
      };
    }

    case GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB: {
      return {
        ...state,
        collaboratorPerformanceWidgets: payload
      }
    }

    case GET_WIDGETS_FOR_USER_PERFORMANCE_TAB: {
      return {
        ...state,
        userPerformanceWidgets: payload
      }
    }

    case GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB: {
      return {
        ...state,
        customerAnalysisWidgets: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initState;
    }

    default:
      return state;
  }
};

export default analytics;
